import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const EquipmentsService = {
    list: async (payload) => axios.post(API_URL + "/equipments/list", payload).then(({ data }) => data).catch((err) => { throw err }),

    getById: async (id) => axios.get(API_URL + `/equipments/${id}`).then(({ data }) => data).catch((err) => { throw err}),

    allEquipments: async () => axios.get(API_URL + `/equipments/get/allEquipments`).then(({ data }) => data.data).catch((err) => { throw err}),

    create: async (payload) => axios.post(API_URL + "/equipments", payload).then(({ data }) => data).catch((err) => { throw err}),

    update: async (id, payload) => axios.put(API_URL + `/equipments/${id}`, payload).then(({ data }) => data).catch((err) => { throw err}),

    delete: async (id) => axios.delete(API_URL + `/equipments/${id}`).then(({ data } ) => data).catch((err) => { throw err}),
}

export default EquipmentsService;